import {HStack, RadioCard} from "@chakra-ui/react"

export function RadioCardGroup(
    {
        options,
        value,
        defaultValue,
        onChange,
        label,
        orientation = "row",
        spacing = 4,
        showDescription = true,
        colorPalette,
        variant,
    }) {
    const Stack = orientation === "row" ? HStack : "div"

    return (
        <RadioCard.Root
            value={value}
            defaultValue={defaultValue}
            onValueChange={({value}) => onChange?.(value)}
            colorPalette={colorPalette}
            variant={variant}
        >
            {label && <RadioCard.Label>{label}</RadioCard.Label>}
            <Stack gap={spacing} align="stretch">
                {options.map((option) => (
                    <RadioCard.Item
                        key={option.value}
                        value={option.value}
                        disabled={option.disabled}
                    >
                        <RadioCard.ItemHiddenInput/>
                        <RadioCard.ItemControl>
                            {option.description && showDescription ? (
                                <RadioCard.ItemContent>
                                    <RadioCard.ItemText>{option.label}</RadioCard.ItemText>
                                    <RadioCard.ItemDescription>
                                        {option.description}
                                    </RadioCard.ItemDescription>
                                </RadioCard.ItemContent>
                            ) : (
                                <RadioCard.ItemText>{option.label}</RadioCard.ItemText>
                            )}
                            <RadioCard.ItemIndicator/>
                        </RadioCard.ItemControl>
                    </RadioCard.Item>
                ))}
            </Stack>
        </RadioCard.Root>
    )
}